// // @flow

import React from 'react';
import printWindow from '../../../commons/printPages/printHelper';
import { paymentTypeMap } from '../../../../services/helpers';

const iciciBankLogo = require('../../../../assets/images/icici_bank.jpg');

type Props = {
  printData: Object,
  depositType: string,
  collectionAmount?: number,
  denominationDetails?: Object,
  grandTotal?: number,
  updatePrintClicked: Function
};

const denominations = [2000, 500, 200, 100, 50, 20, 10, 5, 2, 1];
class PrintDepositSlip extends React.Component<Props> {
  componentDidMount() {
    if (this.props.printData) {
      printWindow('print-deposit-slip');
    }
    this.props.updatePrintClicked();
  }

  componentDidUpdate() {
    if (this.props.printData) {
      printWindow('print-deposit-slip');
    }
  }

  renderCellValue(cellValue) {
    return cellValue ? <div>{cellValue}</div> : '';
  }

  renderDenominationValueOrAmount(depositType, index, amount) {
    if (!denominations[index] && depositType === paymentTypeMap.CASH.key) {
      return '';
    }
    return depositType === paymentTypeMap.CASH.key
      ? this.props.denominationDetails[denominations[index]] *
          denominations[index] || 0
      : this.renderCellValue(amount);
  }

  renderRows(consignments: Array<any>) {
    return (
      consignments &&
      consignments.map((row, i) => (
        <tr key={i} style={{ pageBreakInside: 'avoid' }}>
          <td colSpan={1}>
            <div>{i + 1}.</div>
          </td>
          <td colSpan={2}>
            {row.chequeNumber ? <div>{row.chequeNumber}</div> : ''}
          </td>
          <td colSpan={2}>{row.bankName ? <div>{row.bankName}</div> : ''}</td>
          <td colSpan={1}>
            {row.branchName ? <div>{row.branchName}</div> : ''}
          </td>
          <td colSpan={2}>
            {row.chequeIssuedBy ? <div>{row.chequeIssuedBy}</div> : ''}
          </td>

          <td colSpan={2} />

          {denominations[i] ? (
            <td style={{ textAlign: 'right' }}>{`${denominations[i]} X`}</td>
          ) : (
            <td />
          )}
          {denominations[i] ? (
            <td>
              {(this.props.depositType === paymentTypeMap.CASH.key &&
                (this.props.denominationDetails[denominations[i]] || '0')) ||
                ''}
            </td>
          ) : (
            <td />
          )}
          <td style={{ textAlign: 'right' }}>
            {this.renderDenominationValueOrAmount(
              this.props.depositType,
              i,
              row.amount
            )}
          </td>
        </tr>
      ))
    );
  }

  renderForDenominations(data: Object, tableDataLength) {
    const remainings = denominations.slice(tableDataLength);
    return remainings.map((row, i) => (
      <tr key={i + tableDataLength} style={{ pageBreakInside: 'avoid' }}>
        <td colSpan={1}>
          <div>{i + 1 + tableDataLength}</div>
        </td>
        <td colSpan={2} />
        <td colSpan={2} />
        <td colSpan={1} />
        <td colSpan={2} />
        <td colSpan={2} />
        {remainings[i] ? (
          <td style={{ textAlign: 'right' }}>{`${remainings[i]} X`}</td>
        ) : (
          <td />
        )}
        {remainings[i] ? (
          <td>
            {(this.props.depositType === paymentTypeMap.CASH.key &&
              (this.props.denominationDetails[remainings[i]] || '0')) ||
              ''}
          </td>
        ) : (
          <td />
        )}
        {remainings[i] ? (
          <td style={{ textAlign: 'right' }}>
            {this.props.denominationDetails[remainings[i]] * remainings[i] || 0}
          </td>
        ) : (
          <td />
        )}
      </tr>
    ));
  }

  renderDepositSlipPrint(data: Object) {
    return (
      <div id="deposit-slip-print-view" className="print-view">
        <header style={{ textAlign: 'center' }} />
        <table id="slip-details" style={{ tableLayout: 'auto' }}>
          <tbody>
            <tr>
              <td colSpan={4} style={{ textAlign: 'left', border: 'none' }}>
                <b style={{ fontSize: '1.4rem' }}>CASH MANAGEMENT SERVICES</b>
              </td>
              <td colSpan={4} style={{ textAlign: 'right', border: 'none' }}>
                <img
                  src={iciciBankLogo}
                  alt="ICICI Bank Logo"
                  width="165px"
                  height="40px"
                />
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: 'right', border: 'none' }} colSpan={1}>
                Client Name :
              </td>
              <td
                style={{ border: 'none', borderBottom: '1px dashed black' }}
                colSpan={3}
              >
                <b>{data.depositSlipDTO.clientName}</b>
              </td>

              <td style={{ textAlign: 'right', border: 'none' }} colSpan={1}>
                Deposit Slip Number :{' '}
              </td>
              <td
                style={{ border: 'none', borderBottom: '1px dashed black' }}
                colSpan={3}
              >
                <b>{data.depositSlipDTO.depositSlipNumber}</b>
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: 'right', border: 'none' }} colSpan={1}>
                CMS Code :{' '}
              </td>
              <td
                style={{ border: 'none', borderBottom: '1px dashed black' }}
                colSpan={1}
              >
                <b>{data.depositSlipDTO.cmsCode}</b>
              </td>
              <td style={{ textAlign: 'right', border: 'none' }} colSpan={1}>
                Select the mode :{' '}
              </td>
              <td
                style={{ border: 'none', borderBottom: '1px dashed black' }}
                colSpan={1}
              >
                <b>{data.depositSlipDTO.depositType}</b>
              </td>
              <td style={{ textAlign: 'right', border: 'none' }} colSpan={1}>
                No. of Instruments :{' '}
              </td>
              <td
                style={{ border: 'none', borderBottom: '1px dashed black' }}
                colSpan={1}
              >
                <b>{data.depositSlipDTO.numberOfInstruments}</b>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: 'right', border: 'none' }} colSpan={1}>
                Pick up Date :{' '}
              </td>
              <td
                style={{ border: 'none', borderBottom: '1px dashed black' }}
                colSpan={1}
              >
                <b>{data.depositSlipDTO.depositSlipGenerationDate}</b>
              </td>
              <td style={{ textAlign: 'right', border: 'none' }} colSpan={1}>
                Pickup location :{' '}
              </td>
              <td style={{ border: 'none', borderBottom: '1px dashed black' }}>
                <b>{data.depositSlipDTO.pickupBranch}</b>
              </td>
              <td style={{ textAlign: 'right', border: 'none' }} colSpan={1}>
                Pickup point :{' '}
              </td>
              <td style={{ border: 'none', borderBottom: '1px dashed black' }}>
                <b>{data.depositSlipDTO.pickupPoint}</b>
              </td>
              <td style={{ textAlign: 'right', border: 'none' }} colSpan={1}>
                Deposit Date :{' '}
              </td>
              <td
                style={{
                  border: 'none',
                  borderBottom: '1px dashed black',
                  width: '6rem'
                }}
              >
                {/* <b>{data.depositSlipGenerationDate}</b> */}
                <span />
              </td>
            </tr>
          </tbody>
        </table>
        <table id="main-table">
          <thead style={{ lineHeight: '2.5' }}>
            <tr style={{ textAlign: 'center' }}>
              <td colSpan={1}>
                <b>Sr. No. </b>
              </td>
              <td colSpan={2}>
                <b>Cheque Number</b>
              </td>
              <td colSpan={2}>
                <b>Bank Name</b>
              </td>
              <td colSpan={1}>
                <b>Branch Location</b>
              </td>
              <td colSpan={2}>
                <b>Cheques Issued by</b>
              </td>
              <td colSpan={2}>
                <b>Client Code/Remarks</b>
              </td>

              <td colSpan={2}>
                <b>Denomination (Cash Deposit)</b>
              </td>

              <td colSpan={1}>
                <b>Rupees</b>
              </td>
            </tr>
          </thead>

          <tbody>
            {this.renderRows(data.depositSlipRowDTOList)}
            {data.depositSlipRowDTOList &&
            data.depositSlipRowDTOList.length < 10
              ? this.renderForDenominations(
                  this.props.denominationDetails,
                  data.depositSlipRowDTOList.length
                )
              : null}
            <tr>
              <td colSpan={10} />
              <td colSpan={2}>
                <b>Total</b>
              </td>
              <td style={{ textAlign: 'right' }}>
                {this.props.depositType === paymentTypeMap.CASH.key
                  ? this.props.grandTotal
                  : this.props.collectionAmount}
              </td>
            </tr>
          </tbody>
        </table>
        <table>
          <tbody>
            <tr>
              <td
                colSpan={1}
                style={{ border: 'none', borderBottom: '1px solid black' }}
              />
              <td
                colSpan={1}
                style={{ border: 'none', borderBottom: '1px solid white' }}
              />
              <td
                colSpan={1}
                style={{ border: 'none', borderBottom: '1px solid black' }}
              />
              <td
                colSpan={1}
                style={{ border: 'none', borderBottom: '1px solid white' }}
              />
              <td
                colSpan={1}
                style={{ border: 'none', borderBottom: '1px solid black' }}
              />
              <td
                colSpan={1}
                style={{ border: 'none', borderBottom: '1px solid white' }}
              />
            </tr>
            <tr>
              <td colSpan={2} style={{ border: 'none' }}>
                <b>Deposited By</b>
              </td>
              <td colSpan={2} style={{ border: 'none' }}>
                <b>Branch</b>
              </td>
              <td colSpan={2} style={{ border: 'none' }}>
                <b>Bank Stamp</b>
              </td>
            </tr>
            <tr />
            <tr style={{ border: 'none', pageBreakInside: 'avoid' }}>
              <td colSpan={8} style={{ border: 'none' }}>
                *Credit to your a/c is based on CMS Code mentioned above. Please
                ensure to fill correct client code.
              </td>
            </tr>

            <tr style={{ border: 'none', pageBreakInside: 'avoid' }}>
              <td colSpan={8} style={{ border: 'none' }}>
                <b
                  style={{
                    textDecoration: 'underline'
                  }}
                >
                  Disclaimer:
                </b>
              </td>
            </tr>
            <tr style={{ border: 'none', pageBreakInside: 'avoid' }}>
              <td colSpan={8} style={{ border: 'none' }}>
                <b>
                  “Instruments deposited are not checked at the time of deposit.
                  It is received subject to subsequent verification and
                  scrutiny. Credit allowed for such instruments drawn on the
                  bank or on the other bank or party is only provisional in
                  nature until the money has actually been received in payment
                  towards such items. The amount of any instrument may be
                  charged back unless the instrument received in payment thereof
                  be honoured in due course. In receiving items for deposit or
                  collection, this bank acts only as the depositor’s collecting
                  agent and assumes no responsibility beyond the exercise of due
                  care.”
                </b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    return (
      <div
        id="print-deposit-slip"
        style={{ display: 'none', position: 'absolute' }}
      >
        {this.renderDepositSlipPrint(this.props.printData)}
      </div>
    );
  }
}
PrintDepositSlip.defaultProps = {
  grandTotal: 0,
  denominationDetails: {}
};

export default PrintDepositSlip;
